import { useStytchB2BClient } from '@stytch/react/b2b';
import React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    H5Regular,
    Spinner,
    YStack,
} from 'smoothie';

import { GroveLogo } from '../../common/components/GroveLogo';
import { STYTCH_ORGANIZATION_ID } from '../../config/config';
import { useRefreshStalePage } from '../hooks/useRefreshStalePage';

const LogIn = () => {
    useRefreshStalePage();
    const [isWaiting, setIsWaiting] = React.useState(false);
    const stytchClient = useStytchB2BClient();

    const startOAuth = async () => {
        await stytchClient.oauth.microsoft.start({
            organization_id: STYTCH_ORGANIZATION_ID,
            login_redirect_url: `${window.location.origin}/sign-in/authenticate`,
            signup_redirect_url: `${window.location.origin}/sign-in/authenticate`,
        });
    };

    const handleLogIn = async () => {
        setIsWaiting(true);
        await startOAuth();
    };

    return (
        <YStack
            justifyContent="space-between"
            width="100%"
            height="100%"
            padding={96}
        >
            <GroveLogo isLarge />
            <YStack width="100%" alignItems="center" gap={32} padding={64}>
                {isWaiting ? <Spinner /> : <H5Regular>Welcome</H5Regular>}
                <button // Wrap inner button in this so we can enable login via 'enter' key on load
                    type="submit"
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus={true}
                    onClick={handleLogIn}
                    style={{ width: '100%' }}
                >
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text={
                            isWaiting
                                ? 'Logging in...'
                                : 'Log in with Microsoft SSO'
                        }
                        onPress={handleLogIn}
                        disabled={isWaiting}
                    />
                </button>
            </YStack>
        </YStack>
    );
};

export default LogIn;
